import { RootStore } from '../rootStore';
import { ADMIN_PORTFOLIOS } from 'api/endpoints';
import { observable, action } from 'mobx';

interface Portfolio {
  code: string;
  users: string[];
}

export class AdminPortfoliosStore {
  rootStore: RootStore;
  @observable list: Portfolio[] = [];

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  fetchList = async () => {
    const { uiStore, apiStore } = this.rootStore.stores;
    uiStore.setLoading(true);
    const response = await apiStore.get<Portfolio[]>(ADMIN_PORTFOLIOS);
    if (response?.data) {
      this.list = response.data;
    }
    uiStore.setLoading(false);
  };

  saveList = async (code: string, users: string[]) => {
    const { uiStore, apiStore } = this.rootStore.stores;
    uiStore.setLoading(true);
    await apiStore.post(ADMIN_PORTFOLIOS, { code, users });
    await this.fetchList();
    uiStore.setLoading(false);
  };

  addUser = async (code: string, user: string) => {
    const newGroup = this.list.find((p) => p.code === code)?.users?.concat(user.split(',').map((u) => u.trim()));
    newGroup && (await this.saveList(code, newGroup));
  };

  removeUser = async (code: string, user: string) => {
    const newGroup = this.list.find((p) => p.code === code)?.users?.filter((u) => u !== user);
    newGroup && (await this.saveList(code, newGroup));
  };

  editUsers = async (code: string, users: string) => {
    const newGroup = users.split(',').map((u) => u.trim());
    await this.saveList(code, newGroup);
  };
}
